import { Component, ViewChild } from '@angular/core';
import { NavController, LoadingController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationServices } from '../../services';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { ConfigurationCloseCashCreate } from '../configuration-close-cash-create/configuration-close-cash-create';

@Component({
  selector: 'page-configuration-close-cash-list',
  templateUrl: 'configuration-close-cash-list.html'
})

export class ConfigurationCloseCashList {

  sorts = [
    { prop: 'date_final', dir: 'asc' },
    { prop: 'name', dir: 'asc' },
    { prop: 'cash_init', dir: 'asc' },
    { prop: 'cash_total', dir: 'asc' },
    { prop: 'cash_mismatch', dir: 'asc' },
    { prop: 'comment', dir: 'asc' }
  ];

  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };


  constructor(public navCtrl: NavController,
    public globals: Globals,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    public translate: TranslateService,
    private configurationServices: ConfigurationServices) {
  }

  openCloseCashView(event) {
    if (event.type == 'click') {
      this.navCtrl.push(ConfigurationCloseCashCreate, {
        action: 'view',
        close_cash: event.row
      });
    }
  }

  onSort(event) {
    var history_array = this.configurationServices.biclosecash_history_close_cash;

    switch (event.column.name) {
      case 'date_final':
        if (event.newValue == 'asc') {
          history_array.sort((a, b) => a.date_final.localeCompare(b.date_final));
        } else {
          history_array.sort((a, b) => b.date_final.localeCompare(a.date_final));
        }
        break;
      case 'name':
        if (event.newValue == 'asc') {
          history_array.sort((a, b) => a.name.localeCompare(b.name));
        } else {
          history_array.sort((a, b) => b.name.localeCompare(a.name));
        }
        break;
      case 'cash_init':
        if (event.newValue == 'asc') {
          history_array.sort((a, b) => a.cash_init - b.cash_init);
        } else {
          history_array.sort((a, b) => b.cash_init - a.cash_init);
        }
        break;
      case 'cash_total':
        if (event.newValue == 'asc') {
          history_array.sort((a, b) => a.cash_total - b.cash_total);
        } else {
          history_array.sort((a, b) => b.cash_total - a.cash_total);
        }
        break;
      case 'cash_mismatch':
        if (event.newValue == 'asc') {
          history_array.sort((a, b) => a.cash_mismatch - b.cash_mismatch);
        } else {
          history_array.sort((a, b) => b.cash_mismatch - a.cash_mismatch);
        }
        break;
      case 'comment':
        if (event.newValue == 'asc') {
          history_array.sort((a, b) => a.comment.localeCompare(b.comment));
        } else {
          history_array.sort((a, b) => b.comment.localeCompare(a.comment));
        }
        break;

    }
    this.configurationServices.biclosecash_history_close_cash = history_array;
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-close-cash/configuration-close-cash-list/configuration-close-cash-list.ts